module.exports = __webpack_public_path__ + "img/大华集团.8e5d649c.png";